import Vue from 'vue';
import CookiesUtil from 'src/utils/cookies';
import Modal from 'src/components/widgets/Modal.vue';
export default Vue.extend({
    components: { Modal },
    data() {
        return {
            inTransition: false,
            step: 'intro'
        };
    },
    mounted() {
        this.$nextTick(() => {
            if (!CookiesUtil.isSet('data-tutorial')) {
                this.show();
                CookiesUtil.setOption('data-tutorial');
            }
        });
    },
    methods: {
        close() {
            this.$refs.modal.hide();
        },
        // Go to next step
        // `inTransition` is used to hide the modal while the modal content is being replaced
        // and modal position recalculated; this is to avoid an ugly flicker modal position gets
        // adjusted.
        next() {
            // this.inTransition = true
            this.$refs.modal.$el.classList.add('hidden');
            if (this.step === 'intro') {
                this.step = 'organise';
            }
            else if (this.step === 'organise') {
                this.step = 'headers';
            }
            else if (this.step === 'headers') {
                this.step = 'sufficient';
            }
            setTimeout(() => {
                this.$refs.modal.refresh(); // recalculate modal positions
                this.$nextTick(() => {
                    this.$refs.modal.$el.classList.remove('hidden');
                });
            }, 100); // need a delay (as opposed to nextTick) for
            // modal.refresh to recalculate position accurately
        },
        show(step) {
            if (step) {
                this.step = step;
            }
            this.$refs.modal.show();
        }
    }
});
